// extracted by mini-css-extract-plugin
module.exports = {"BottomTips":"BottomTips_BottomTips__t8gw0"};